<main class="flex justify-center w-full min-h-screen bg-[#dc83320f] p-2 md:p-6 pt-6">
  <div class="w-full">
    <div class="flex flex-col transition-all duration-300 ease-in-out gap-6" [ngClass]="{'lg:ml-64': menuOpen()}">
      <div class="flex relative h-12">
        <button (click)="toggleMenu()"
                class="cursor-pointer focus:outline-none transition-opacity"
                [ngClass]="{'opacity-0': menuOpen()}"
        >
          <svg width="30" height="30" fill="none" viewBox="0 0 30 30" stroke="currentColor"
               xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>
        <img src="/images/logo.svg" alt="" class="absolute size-full pointer-events-none select-none">
      </div>

      <div class="pb-12">
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-sidemenu [menuOpen]="menuOpen()" (closeMenu)="menuOpen.set(false)"></app-sidemenu>
  </div>
</main>
<app-loader></app-loader>
<app-error-modal></app-error-modal>
